// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable hydrogen/prefer-image-component */
// @ts-ignore
import {Navigation, Controller, FreeMode, SwiperClass} from 'swiper';
// @ts-ignore
import {Swiper, SwiperSlide} from 'swiper/react';
import clsx from 'clsx';
import {useState} from 'react';
import {IconArrow} from '../icons/IconArrow';
import iconCheck from '../../assets/icons/icon-check.svg';
import iconPlay from '../../assets/icons/icon-play.svg';
import {DATA_TEST_IDS} from '~/lib/const';
import SanityImage from '../media/SanityImage.client';
import sanityConfig from '../../../sanity.config';
import {ProductGalleryEntity} from '~/types';
import throttle from '~/lib/throttle';
import ProductGalleryCustomMobile from './ProductGalleryCustomMobile.client';

export function ProductGalleryCustom({data}: {data: ProductGalleryEntity}) {
  const {images} = data ?? {};
  const [swiper, setSwiper] = useState<SwiperClass>({});
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndexThrottled = throttle(
    100,
    (sIndex: number) => setActiveIndex(sIndex),
    {noLeading: true, noTrailing: false},
  );

  // Dont render if images are missing or mobile is not set
  if (images == null || images.length === 0) return null;

  return (
    <>
      <div className="md:hidden">
        <ProductGalleryCustomMobile images={images} />
      </div>
      <div className="hidden md:block">
        <div className="grid grid-cols-1 overflow-hidden h-full">
          <div className="flex items-center mt-10 gap-[52px] md:gap-[52px]">
            <button
              type="button"
              className={clsx(
                'w-12 h-12 rounded-full flex items-center justify-center border-2 border-blue-500 group cursor-pointer flex-shrink-0 mt-[26px]',
                'enabled:hover:bg-blue-500 enabled:hover:text-white',
              )}
              onClick={() => swiper?.slidePrev()}
            >
              <IconArrow className="w-[8.48px] h-[16.06px] rotate-180" />
            </button>

            <Swiper
              onSwiper={(s) => {
                setSwiper(s);
              }}
              // @ts-expect-error
              modules={[Navigation, FreeMode, Controller]}
              onSlideChange={(swiper) => {
                const sIndex = swiper.activeIndex;
                updateIndexThrottled(sIndex);
              }}
              className={'relative'}
              effect="fade"
              centeredSlides
              allowTouchMove={true}
              slidesPerView={1}
              cssMode={false}
              shortSwipes={true}
              threshold={10}
            >
              {images?.map((med, index) => (
                <SwiperSlide
                  // @ts-ignore
                  key={med?.asset?._ref}
                >
                  <div className="h-full">
                    <SanityImage
                      alt={`gallery ${index}`}
                      dataset={sanityConfig.dataset}
                      layout="responsive"
                      projectId={sanityConfig.projectId}
                      src={med?.asset?._ref}
                      className="rounded-[10px] lg:rounded-none object-contain h-[300px] md:h-[400px] lg:h-[600px]"
                      breakpoints={[
                        [360, 180],
                        [906, 460],
                        [1200, 800],
                      ]}
                      disableFitCrop
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <button
              data-testid={DATA_TEST_IDS.BUTTON('next')}
              type="button"
              className={clsx(
                'w-12 h-12 rounded-full flex items-center justify-center border-2 border-blue-500 group cursor-pointer flex-shrink-0 mt-[26px]',
                'enabled:hover:bg-blue-500 enabled:hover:text-white',
              )}
              onClick={() => swiper?.slideNext()}
            >
              <IconArrow className="w-[8.48px] h-[16.06px]" />
            </button>
          </div>
        </div>
        <div className="h-full flex flex-wrap -ml-[15px]">
          {images?.map((med, index) => (
            <button
              key={med?.asset?._ref}
              data-testid={DATA_TEST_IDS.BUTTON('prev')}
              type="button"
              // @ts-ignore
              onClick={() => swiper?.slideTo(index)}
              className={clsx(
                'relative h-full ml-[15px] mt-[15px]',
                index === activeIndex
                  ? 'border-blue-500 border-2'
                  : 'border-white',
              )}
              style={{
                width: '100px',
                height: '100px',
              }}
            >
              <SanityImage
                alt={`gallery ${index}`}
                dataset={sanityConfig.dataset}
                layout="responsive"
                objectFit="cover"
                projectId={sanityConfig.projectId}
                src={med?.asset?._ref}
                className="rounded-[10px] lg:rounded-none object-cover"
                breakpoints={[
                  [100, 100],
                  [200, 200],
                  [300, 300],
                ]}
              />

              {index === activeIndex ? (
                <div className="w-10 h-10 rounded-full bg-blue-500 grid place-items-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <img loading="lazy" src={iconCheck} alt="Selected" />
                </div>
              ) : (
                (med.mediaContentType === 'VIDEO' ||
                  med.mediaContentType === 'EXTERNAL_VIDEO') && (
                  <div className="w-10 h-10 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                    <img loading="lazy" src={iconPlay} alt="Video" />
                  </div>
                )
              )}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
